// Canonical app-relative URL shapes for the public Places / Guides
// features. This is the ONE definition — client/src/utils/places.js and
// client/src/utils/posts.js re-export these, and the server builds
// canonical / og:url from them too, so the URL a page links to, the URL in
// its canonical tag, and the URL in the sitemap can never disagree.
export const placesListPath = (city) =>
  `/places/${encodeURIComponent((city || "").toLowerCase())}`;

export const placeDetailPath = (city, slugOrId) =>
  `${placesListPath(city)}/${encodeURIComponent(slugOrId)}`;

export const guidesListPath = (city) =>
  city ? `/guides/${encodeURIComponent((city || "").toLowerCase())}` : "/guides";

export const guideDetailPath = (city, slug) =>
  `/guides/${encodeURIComponent((city || "").toLowerCase())}/${encodeURIComponent(slug)}`;
